import api from './api'

export const getWishlist = () => {
  return api.call('get', '/wishlist/show').then(api.getData)
}

export const addToWishlist = (sku, variant) => {
  return api.call('post', `/wishlist/add`, { sku, variant })
}

export const deleteFromWishlist = sku => {
  return api.call('post', `/wishlist/delete`, { sku })
}

export const moveToCart = sku => {
  return api.call('post', `/wishlist/move-to-cart`, { sku })
}

export const clearWishlist = () => {
  return api.call('post', `/wishlist/clear`)
}

export const moveAllToCart = () => {
  return api.call('post', `/wishlist/move-all-to-cart`)
}
